import I18n from 'i18n-js';
import React from 'react';
import RQLHomepageFeed from '../../../feed/rql_homepage_feed';
import { HomepageDealsAndStealsPersonalizedListingsCollection } from '../../homepage_deals_and_steals_personalized_listings_collection';
import RecommendedListingsRow from '../../recommended_listings/recommended_listings_row';
import { Paths } from '../../shared/url_helpers';
import HomepageCategories from '../homepage_categories';
import RegionalListings from '../regional_listings';
import { buyingGuideEligibleRegionAndLocale } from '../user_helper';
import RecentArticles from './recent_articles';

import CmsPageCards, { CMS2_PAGE } from '@reverbdotcom/commons/src/cms/components/cms_page_cards';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import CMSSearchInputGroup from '@reverbdotcom/commons/src/components/cms_search_input_group';
import { OverflowingRowAction } from '@reverbdotcom/commons/src/components/overflowing_row_action';
import WatchedListings from '@reverbdotcom/commons/src/components/watched_listings';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MY_FAVORITES_WATCH_LIST_ROUTE_PATH } from '../../shared/constants';
import RecentlyViewedListings from '@reverbdotcom/commons/src/cms/components/recently_viewed_listings';
import { ExperimentalPromotedListingsRow } from './experimental_promoted_listings_row';
import { HomepageWelcome } from './homepage_welcome';
import { JustListedForYouRow } from './just_listed_for_you';
import HomepageNotifications from './homepage_notifications';

function BuyingGuides(_props) {
  const user = useUser();
  if (buyingGuideEligibleRegionAndLocale(user.shippingRegionCode, user.locale)) {
    return (
      <div className="homepage-container__component-wrapper">
        <CmsPageCards
          title={I18n.t('discovery.homepage.buyingGuides.buyingGuidesHeading')}
          pageFields={[
            { pageSource: CMS2_PAGE, slug: 'buying-guide-acoustic-guitars' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-telecasters' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-audio-interfaces' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-gibson-les-pauls' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-affordable-monosynths' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-reverb-pedals' },
          ]}
          ssr={false}
          action={
            <OverflowingRowAction
              href={Paths.buyingGuide.expand({})}
              text={I18n.t('discovery.homepage.buyingGuides.seeMore')}
            />
          }
        />
      </div>
    );
  }

  return <HomepageCategories />;
}

function WatchListSection(_props) {
  return (
    <div className="homepage-container__component-wrapper">
      <WatchedListings
        mainCallToAction={(
          <OverflowingRowAction
            href={MY_FAVORITES_WATCH_LIST_ROUTE_PATH}
            text={I18n.t('commons.watchRow.loggedIn.cta')}
          />
        )}
        secondaryCallToAction={(
          <>
            <div className="inner-call-to-action__mobile">
              <CMSSearchInputGroup
                actionUrl={Paths.marketplace.expand({})}
                placeholder={I18n.t('commons.watchRow.loggedIn.emptyState.condensedCta')}
              />
            </div>
            <div className="inner-call-to-action__non-mobile">
              <CMSSearchInputGroup
                actionUrl={Paths.marketplace.expand({})}
                placeholder={I18n.t('commons.watchRow.loggedIn.emptyState.cta')}
              />
            </div>
          </>
        )}
      />
    </div>
  );
}

export function LoggedInHomepage(_props) {
  const user = useUser();

  return (
    <>
      <div className="homepage-container bg-white pt-half">
        <HomepageWelcome />
        <HomepageNotifications />
        {/* Recently Viewed Listings */}
        <div className="dynamic-page__one-col">
          <RecentlyViewedListings title={I18n.t('discovery.homepage.recentlyViewed')} layoutSection="main" pagePosition={1} ssr={true} />
        </div>
        {/* The Latest from Your Feed */}
        <RQLHomepageFeed />
        {/* From Your Watch List */}
        <WatchListSection />
        {/* Just Listed for You */}
        <JustListedForYouRow />
        {/* Deals & Steals for You */}
        <HomepageDealsAndStealsPersonalizedListingsCollection />
        {/* Recommended for You */}
        <div className="homepage-container__component-wrapper">
          <RecommendedListingsRow limit={12} />
        </div>
        {/* Listings in {{COUNTRY}} */}
        <RegionalListings />
        {/*
          Buying Guides
          Categories
        */}
        <BuyingGuides />
        {/* Recent Articles */}
        <div className="homepage-container__component-wrapper">
          <RecentArticles
            action={
              <OverflowingRowAction
                href={Paths.articlesSearch.expand({})}
                text={I18n.t('discovery.homepage.buyingGuides.seeMore')}
              />
            }
          />
        </div>
        {/*
          Promoted Listings
          Best Sellers
          Free Two-day Shipping
          0% Financing Available
          From Your Recent Search
          JustListed
        */}
        <div className="homepage-container__component-wrapper">
          <ExperimentalPromotedListingsRow />
        </div>
        {/*
          CmsEmbed: homepage-embed
          - Find a Deal
          - Reverb Staff Picks
        */}
        {!isExperimentEnabled(user, experiments.DEALS_AND_STEALS_HOME) &&
          <div className="homepage-container__component-wrapper">
            <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
          </div>
        }
        {/*
          CmsEmbed: admin-homepage-test-component
        */}
        {isExperimentEnabled(user, experiments.ADMIN_HOMEPAGE_CMS_EMBED) &&
          <div className="homepage-container__component-wrapper">
            <CmsEmbed slug="admin-homepage-test-component" ssrMode="full" />
          </div>
        }
      </div>
    </>
  );
}

export default LoggedInHomepage;
